
import React from 'react';
import PropTypes from 'prop-types';
import { Excerpt } from 'audamatic-ui';
import Text from '@components/ui_text/component';
import { t } from  '@utils/i18n';
import Typeset from '../base_typeset/component';
import { FILTER_BESTSELLERS, FILTER_RECENT, FILTER_PREORDER } from '@constants';
import './styles/styles.scss';

const CategoryIntroduction = (props) => {
  const {
    displayTitle = false,
    title = '',
    description = '',
    overlap,
    preset = false,
    categoryUrlPath,
  } = props;

  let categoryText = '';
  let categoryTextClickCollect = '';
  const isBook = title !== 'eBooks';

  if (preset) {
    const category = title.toLowerCase();

    if (categoryUrlPath === FILTER_BESTSELLERS) {
      categoryText = t('seo.category.bestseller', { replacements: { category } });
      categoryTextClickCollect = t('seo.category.bestseller-clickcollect', { replacements: { category } });
    }
    if (categoryUrlPath === FILTER_RECENT) {
      categoryText =  t('seo.category.newest', { replacements: { category } });
      categoryTextClickCollect = t('seo.category.newest-clickcollect', { replacements: { category } });
    }
    if (categoryUrlPath === FILTER_PREORDER) {
      categoryText =  t('seo.category.preorder', { replacements: { category } });
    }
  } else {
    categoryText = description;
  }

  return (
    <div className={`${displayTitle ? `page-seo ${overlap ? 'overlap' : ''}` : 'category-introduction'}`} >
      <div className="container">
        {!preset && (
          <Typeset tag="div" scale="0" bold testId="seoTitle">{title}</Typeset>
        )}
        <Excerpt
          text={`${categoryText} ${isBook ? categoryTextClickCollect : ''}`}
          columnCount={2}
          maxLinesSm={8}
          label1={<Text>common.link.readmore</Text>}
          label2={<Text>common.link.readless</Text>}
        />
      </div>
      <div id="block-recommendations"></div>
    </div>
  );
};


CategoryIntroduction.propTypes = {
  /**
   * Boolean to show the title
   * Default is set to false
   */
  displayTitle: PropTypes.bool,
  /**
   * Boolean to show the description
   * Default is set to false
   */
  displayDescription: PropTypes.bool,
  /**
   * The title of the introduction, most commonly used is the category name
   */
  title: PropTypes.string,
  /**
   * The full description of the introduction
   */
  description: PropTypes.string,
  /** Should overlap with the footer? */
  overlap: PropTypes.bool,
  preset: PropTypes.bool,
  categoryUrlPath: PropTypes.string,
};


export default CategoryIntroduction;
